import { render } from "./VideoManagement.vue?vue&type=template&id=0419bcc8&scoped=true"
import script from "./VideoManagement.vue?vue&type=script&lang=js"
export * from "./VideoManagement.vue?vue&type=script&lang=js"

import "./VideoManagement.vue?vue&type=style&index=0&id=0419bcc8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0419bcc8"]])

export default __exports__